<template>
  <div class="login_info">
    <!-- 关闭按钮 -->
    <div class="close" @click="clickClose">
      <van-icon name="cross" />
    </div>
    <div class="back_to" @click="backTo">
      <van-icon name="arrow-left" />
    </div>
    <!-- <van-nav-bar :title="$t('message.login.rest_pass')" fixed placeholder /> -->
    <div class="login_title">{{ $t('message.login.rest_pass') }}</div>
    <div class="login_info_input">
      <van-form ref="form">
        <!-- <van-field
          v-model="queryInfo.mobile"
          type="number"
          label="+86"
          :placeholder="$t('message.login.please_phone')"
          show-word-limit
          :rules="telRules"
        /> -->
        <VuePhoneNumberInput
          v-model="phone"
          :translations="translations"
          @update="validate"
          class="phoneNumber"
          :preferred-countries="['CN', 'US', 'CA', 'TH', 'KH', 'PT', 'MY', 'JP']"
        />

        <!-- 请输入验证码 -->
        <van-field
          class="sms"
          v-model="queryInfo.smsCode"
          center
          :placeholder="$t('message.login.ver_code')"
        >
          <button
            slot="button"
            native-type="button"
            :disabled="!countdown"
            :class="[countdown ? 'reg_active' : 'reg_disActive']"
            @click="getCode"
            type="button"
          >
            <span v-if="countdown">{{ text }}</span>
            <span v-if="!countdown">{{ text }} ({{ count }})</span>
          </button>
        </van-field>
        <!-- 输入密码 -->
        <van-field
          autocomplete
          v-model="queryInfo.password"
          type="password"
          :placeholder="$t('message.login.please_pass')"
          :rules="[
            {
              required: true,
              message: $t('message.login.pass_null')
            },
            {
              pattern: /^.*(?=.{6,18})(?=.*\d)(?=.*[a-z]{1,}).*$/,
              message: $t('message.login.new_pass_null')
            }
          ]"
        />
        <!-- 再次输入密码 -->
        <van-field
          autocomplete
          v-model="queryInfo.oldPassword"
          type="password"
          :placeholder="$t('message.login.pain_again')"
          :rules="[
            {
              required: true,
              message: $t('message.login.pass_null')
            }
          ]"
        />
      </van-form>
    </div>
    <div class="bottom"></div>
    <div class="login_phone_btn">
      <van-button round v-if="queryInfo.mobile == ''" disabled>{{
        $t('message.login.sign')
      }}</van-button>
      <van-button round v-else @click="submit" v-preventReClick="3000">{{
        $t('message.login.sign')
      }}</van-button>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import 'vue-tel-input/dist/vue-tel-input.css'
import { Toast } from 'vant'
import { forGetlogin, getSms } from '@/api/login'
const defaultQuery = Object.freeze({
  mobile: '',
  password: '',
  oldPassword: '',
  smsCode: ''
})
export default {
  name: 'ForGetPassword',
  data() {
    return {
      countdown: true,
      count: '',
      timer: null,
      text: this.$t('message.login.send_code'),
      queryInfo: { ...defaultQuery },
      checked: true,
      phone: '',
      telRules: [
        {
          required: true,
          message: this.$t('message.login.phone_null'),
          trigger: 'onBlur'
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /0?(13|14|15|17|18|19)[0-9]{9}/.test(value)
          },
          message: this.$t('message.login.correct_phone'),
          trigger: 'onBlur'
        }
      ],
      translations: {}
    }
  },
  components: {
    VuePhoneNumberInput
  },
  created() {
    if (sessionStorage.getItem('lang') == 'zhcn') {
      this.translations = {
        countrySelectorLabel: '国家',
        phoneNumberLabel: '手机号码'
      }
    } else {
      this.translations = {}
    }
  },
  methods: {
    // 返回上一级
    backTo() {
      this.$emit('backTo')
    },
    // 点击关闭
    clickClose() {
      this.$emit('clickClose')
    },
    async getCode() {
      const TIME_COUNT = 60
      if (
        this.queryInfo.mobile === '' ||
        this.queryInfo.mobile == undefined ||
        this.queryInfo.mobile == 'undefined'
      ) {
        Toast.fail(this.$t('message.login.please_phone'))
      } else {
        if (!this.timer) {
          this.count = TIME_COUNT
          this.countdown = false
          this.text = this.$t('message.login.resend')
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.countdown = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        const { data: res } = await getSms({ phone: this.queryInfo.mobile })
        if (res.resultCode === 200) {
          Toast.success(this.$t('message.login.sent_succ'))
        } else {
          Toast.fail(this.$t('message.login.fsiled_send'))
        }
      }
    },
    validate(val) {
      this.queryInfo.mobile = val.formattedNumber
    },
    async submitClick() {
      if (this.queryInfo.smsCode === '') {
        Toast.fail(this.$t('message.login.ver_code'))
      } else {
        const { data: res } = await forGetlogin(this.queryInfo)
        if (res.resultCode === 200) {
          this.$toast({
            duration: 1000,
            message: this.$t('message.login.chang_suc')
          })
          setTimeout(() => {
            this.$router.go(0)
          }, 2000)
        } else {
          this.$toast.fail(res.message)
        }
      }
    },
    submit() {
      if (this.queryInfo.oldPassword === this.queryInfo.password) {
        this.$refs.form
          .validate()
          .then(() => {
            this.submitClick()
          })
          .catch(() => {
            this.$toast.fail(this.$t('message.login.please_com'))
          })
      } else {
        this.$toast.fail(this.$t('message.login.no_pass'))
      }
    },
    registerClick() {
      this.$router.push({
        name: 'registerInfo'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login_info {
  width: 100%;
  // height: 100vh;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 16px;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  .close {
    width: 25px;
    height: 25px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .back_to {
    width: 25px;
    height: 25px;
    cursor: pointer;
    position: absolute;
    left: 10px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sms {
    button {
      background: none;
      border: none;
    }

    .reg_active {
      color: #3562ff;
    }

    .reg_disActive {
      color: #999;
    }
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }

  .login_title {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 15px 0;
    color: #151515;
    font-weight: 500;
    font-size: 20px;
    margin: 15px 0;
    border-bottom: 1px solid #efefef;
    text-align: center;
  }

  .login_info_input {
    width: 100%;
    // overflow: hidden;
    .phoneNumber {
      width: 300px;
      margin: 0 auto;
    }
    .vue-phone-number-input {
      /deep/.input-tel__input {
        border: 0;
        border-top-right-radius: 20px !important;
        border-bottom-right-radius: 20px !important;
        border-right: 0px solid #fff;
        background-color: #f6f6f6;
        height: 46px;
        min-height: 46px;
      }
      /deep/.country-selector__input {
        border: 0;
        border-top-left-radius: 20px !important;
        border-bottom-left-radius: 20px !important;
        border-right: 0px solid #fff;
        background-color: #f6f6f6;
        height: 46px;
        min-height: 46px;
        padding-top: 0;
        padding-left: 50px;
      }
      /deep/.input-tel {
        height: 46px;
        min-height: 46px;
      }
      /deep/.country-selector {
        height: 46px;
        min-height: 46px;
      }
      /deep/.country-selector__label {
        display: none;
      }
      /deep/.country-selector__country-flag {
        top: 50%;
        left: 25%;
        transform: translate(-50%, -50%);
      }
    }
    .van-cell {
      margin: 20px auto 0 auto;
      width: 300px;
      background-color: #f6f6f6;
      border-radius: 32px;

      /deep/.van-field__label {
        width: 40px;
        text-align: center;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .bottom {
    width: 100%;
    overflow: hidden;
    display: flex;
    margin: 24px auto;
    text-align: center;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    text-align: center;

    /deep/ .van-checkbox__label {
      color: #999999;
      font-size: 10px;
      font-weight: 400;
    }

    .div {
      color: #3562ff;
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      margin-left: 2px;
    }
  }

  .login_phone_btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .van-button {
      width: 300px;
      height: 42px;
      box-sizing: border-box;
      text-align: center;
      border: none;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      background: #3562ff;
    }

    /deep/ .van-button--disabled {
      color: #999999;
      background: #ededed;
    }
  }

  .login_text {
    width: 100%;
    overflow: hidden;
    margin: 15px auto;
    width: 300px;
    text-align: right;

    span {
      color: #359eff;
      font-size: 12px;
      font-weight: 400;
    }
  }
}
</style>
